import { apiClient } from "lib/apiClient";

export const deleteMarketAreaSelectedField = async (
  id: string
): Promise<void> => {
  await apiClient.delete(
    `/admin/market-areas/settings/selected/${encodeURIComponent(id)}`
  );
};
